import React from 'react';

import './logo_animated.scss';

const CLASS_NAME = 'logo-animated';
const blue = '#00ADEF';

const LogoAnimated = () => (
  <div className={CLASS_NAME}>
    <svg
      enableBackground="new 75.817 0 84.007 104"
      height="104"
      viewBox="75.817 0 84.007 104"
      width="84.007"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m99.774 0v41.392l20.226-14.11 32.814 19.726c4.358 2.635 7.01 7.315 7.01 12.376v26.866c0 9.811-8.021 17.75-17.891 17.75l-58.026-.139v-27.005l15.867-9.88v21.009h36.929c3.767 0 6.835-3.051 6.835-6.795v-18.443c0-2.531-1.396-4.818-3.626-5.997l-19.912-10.54-44.183 28.219v-19.032l8.125-5.478v-40.004z"
        fill={blue}
        transform=""
      />
    </svg>
  </div>
);

export default LogoAnimated;
